"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditableLabel;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField/TextField.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _EditOutlined = _interopRequireDefault(require("@mui/icons-material/EditOutlined"));
var _Clear = _interopRequireDefault(require("@mui/icons-material/Clear"));
var _Check = _interopRequireDefault(require("@mui/icons-material/Check"));
var _ChopText = _interopRequireDefault(require("./ChopText"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function EditableLabel({
  changeValidation,
  changeValidationMessage,
  disableEdit,
  editMethod = 'button',
  editOnMount = false,
  emptyValue = 'Provide name',
  hideFinishButtons,
  inputProps,
  keyValidation,
  keyValidationMessage,
  onChange,
  textProps,
  value,
  cancelEditOnOutSideClick = true,
  hideCancelFinishButton = false
}) {
  const [edit, setEdit] = (0, _react.useState)(false);
  const [draft, setDraft] = (0, _react.useState)('');
  const [errorMessage, setErrorMessage] = (0, _react.useState)('');
  const inputRef = (0, _react.useRef)(null);
  const errorTimeout = (0, _react.useRef)(null);
  const canClickText = !disableEdit && editMethod === 'click-text';
  (0, _react.useEffect)(() => {
    setEdit(editOnMount);
  }, [editOnMount]);

  // wait for 100ms on blur to see if user already clicked save or cancel button.. then save
  const [blurDone, setBlurDone] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (!blurDone) return;
    if (!cancelEditOnOutSideClick) return;
    if (edit) handleSave();
    setBlurDone(false);
  }, [blurDone]);
  const handleBlur = () => setTimeout(() => setBlurDone(true), 100);
  const handleChange = e => {
    clearTimeout(errorTimeout.current);
    setErrorMessage('');
    setDraft(e.target.value);
  };
  const handleNameKeyDown = e => {
    const {
      key
    } = e;
    if (keyValidation && !keyValidation(key)) {
      if (!keyValidationMessage) return;
      clearTimeout(errorTimeout.current);
      setErrorMessage(keyValidationMessage);
      errorTimeout.current = setTimeout(() => setErrorMessage(''), 5000);
      e.preventDefault();
    } else if (key === 'Enter') {
      handleSave();
    } else if (key === 'Escape') {
      handleCancel(e);
    }
  };
  const handleTextClick = e => {
    e.stopPropagation();
    e.preventDefault();
    handleOpen();
  };
  const handleOpen = () => {
    setErrorMessage('');
    setDraft(value);
    setEdit(true);
  };
  const handleCancel = e => {
    e.stopPropagation();
    e.preventDefault();
    setDraft(value);
    if (cancelEditOnOutSideClick) setEdit(false);
  };
  const showError = msg => {
    clearTimeout(errorTimeout.current);
    setErrorMessage(msg);
    errorTimeout.current = setTimeout(() => setErrorMessage(''), 5000);
  };
  const handleSave = () => {
    const label = draft.trim();
    if (label === value && cancelEditOnOutSideClick) return setEdit(false);
    if (changeValidation) {
      if (Array.isArray(changeValidation)) {
        for (let i = 0; i < changeValidation.length; i++) if (!changeValidation[i](label)) return showError(changeValidationMessage?.[i]);
      } else {
        if (!changeValidation(label)) return showError(changeValidationMessage);
      }
    }
    onChange(label);
    if (cancelEditOnOutSideClick) setEdit(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    children: edit ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
        disableFocusListener: true,
        disableHoverListener: true,
        disableTouchListener: true,
        title: errorMessage,
        open: Boolean(errorMessage),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
          autoFocus: true,
          fullWidth: true,
          value: draft || '',
          onFocus: e => e.target.select(),
          onChange: handleChange,
          onBlur: handleBlur,
          error: Boolean(errorMessage),
          onKeyDown: handleNameKeyDown,
          ref: inputRef,
          variant: "standard",
          ...inputProps
        })
      }), !hideFinishButtons && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        ml: 1,
        display: "flex",
        alignItems: "center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          size: "small",
          onClick: handleSave,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Check.default, {
            fontSize: "small"
          })
        }), !hideCancelFinishButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          size: "small",
          onClick: handleCancel,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Clear.default, {
            fontSize: "small"
          })
        })]
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChopText.default, {
        onClick: canClickText ? handleTextClick : undefined,
        style: canClickText ? {
          cursor: 'text'
        } : undefined,
        color: value ? 'inherit' : 'error',
        ...textProps,
        children: value || emptyValue
      }), !disableEdit && editMethod === 'button' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        size: "small",
        onClick: handleOpen,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditOutlined.default, {
          fontSize: "small"
        })
      })]
    })
  });
}